import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'pcp-ui-icon',
    template: '',
    
})
export class PcpIconComponent {
    @Input() size: string | null = '24px';
    @HostBinding('style.width')  get width() { return this.size ?? ''; }
    @HostBinding('style.height') get height() { return this.size ?? ''; }
}
